import React, { ReactNode, useContext } from 'react';
import {
  DrawerContent,
  DrawerOverlay,
  DrawerWrapper,
} from './styles/Drawer.styles';
import { DirectionContext } from '../../contexts/DirectionContext';
import { Position } from './types/Drawer.types';

type DrawerProps = {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  position: Position;
  size?: string;
  children?: ReactNode;
};

const Drawer = ({
  isOpen,
  setIsOpen,
  children,
  position,
  size = '300px',
}: DrawerProps) => {
  const direction = useContext(DirectionContext);

  return (
    <DrawerWrapper open={isOpen} size={size} position={position}>
      <DrawerOverlay open={isOpen} onClick={() => setIsOpen(false)} />
      <DrawerContent
        open={isOpen}
        size={size}
        position={position}
        backgroundColor={'#ffffff'}
        direction={direction}
      >
        {children as JSX.Element} 
      </DrawerContent>
    </DrawerWrapper>
  );
};

export default Drawer;
